import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        role: '=',
        form: '='
    },
    template: `
        <form role="form" class="form">
            <form-wrapper form="vm.form">
                <form-row error="vm.form.errors.name">
                    <label class="label">{{ 'role.Role name' | translate }} *</label>
                    <div class="items">
                        <input ng-model="vm.form.model.name" type="text" class="form-control" ng-readonly="vm.form.model.code">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <privileges-selection form="vm.form" privileges="vm.privileges"/>
            </form-wrapper>
            <ul class="actions01">
                <li class="primary" ng-if="!(vm.form.model.code && vm.form.model.type == vm.ROLE_TYPE_ENUM.KEYS.SYSTEM_ROLE)">
                    <button ng-click="vm.save()" class="btn main">{{ 'general.Save changes' | translate }}</button></li>
                <li ng-if="vm.form.model.id && !vm.form.model.code">
                    <button ng-click="vm.delete()" class="btn secondary">{{ 'role.Delete role' | translate }}</button>
                </li>
                <li ng-if="!vm.form.model.id">
                    <a ui-sref="authorized.manage.permissions.roles.list()" class="btn discrete" >{{ 'general.Cancel' | translate }}</a>
                </li>
            </ul>
            <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
        </form>
    `
})
export default class {
    constructor ($state, $translate, lodash, toastr,
                 ROLE_PRIVILEGE_ENUM, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM, ROLE_TYPE_ENUM, ROLE_CODE_ENUM,
                 ROLE_PRIVILEGE_EMPLOYEE_ENUM, ROLE_PRIVILEGE_DIRECT_MANAGER_ENUM,
                 RoleService, TokenService) {
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.ROLE_TYPE_ENUM = ROLE_TYPE_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.ROLE_PRIVILEGE_EMPLOYEE_ENUM = ROLE_PRIVILEGE_EMPLOYEE_ENUM;
        this.ROLE_PRIVILEGE_DIRECT_MANAGER_ENUM = ROLE_PRIVILEGE_DIRECT_MANAGER_ENUM;
        this.RoleService = RoleService;
        this.TokenService = TokenService;
    }

    $onInit () {
        // init form privileges to display already gotten privileges
        this.form.model.privileges = this.form.model.privilegesJson;
        this.privileges = this.getPrivileges();
    }

    getPrivileges () {
        let privileges = this.lodash.assign({},
            this.ROLE_PRIVILEGE_ENUM.LABELS,
            this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.LABELS
        );

        if (this.form.model.code === this.ROLE_CODE_ENUM.KEYS.EMPLOYEE) {
            privileges = this.ROLE_PRIVILEGE_EMPLOYEE_ENUM.LABELS;
        }

        if (this.form.model.code === this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER) {
            privileges = this.lodash.assign({},
                this.ROLE_PRIVILEGE_DIRECT_MANAGER_ENUM.LABELS,
                this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.LABELS
            );
        }

        if (!this.TokenService.isFormModuleEnabled()
            && !this.TokenService.isFormEvaluationModuleEnabled()
            && !this.TokenService.isFormSurveyModuleEnabled()) {
            delete privileges.FORMS_MANAGE;
        }

        if (!this.TokenService.isFormEvaluationModuleEnabled()) {
            delete privileges.FORMS_360_MANAGE;
            delete privileges.FORMS_360_REPORT_VIEW;
        }

        if (!this.TokenService.isFormSurveyModuleEnabled()) {
            delete privileges.FORMS_SURVEY_MANAGE;
            delete privileges.FORMS_SURVEY_REPORT_VIEW;
            delete privileges.FORMS_SURVEY_CSV_EXPORT;
        }

        if (!this.TokenService.isPerformanceReviewModuleEnabled()) {
            delete privileges.PERFORMANCE_REVIEW_CONDUCT;
            delete privileges.PERFORMANCE_REVIEW_MANAGE;
        }
        else {
            if (this.form.model.code !== this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER) {
                // this is company module privilege meant for DM only
                delete privileges.PERFORMANCE_REVIEW_CONDUCT;
            }
        }

        if (!this.TokenService.isExternalParticipationModuleEnabled()) {
            delete privileges.EXTERNAL_PARTICIPATIONS_MANAGE;
        }

        if (!this.TokenService.isLicencePointsModuleEnabled()) {
            delete privileges.REPORTS_LICENCE_POINTS_VIEW;
            delete privileges.REPORTS_LICENCE_POINTS_CSV_EXPORT;
        }

        if (!this.TokenService.isBudgetModuleEnabled()) {
            delete privileges.BUDGET_VIEW;
            delete privileges.BUDGET_MANAGE;
            delete privileges.REPORTS_BUDGET_VIEW;
        }

        if (!this.TokenService.isTasklistModuleEnabled()) {
            delete privileges.TASKLIST_MANAGE;
        }

        if (!this.TokenService.isOptionalCoursesModuleEnabled()) {
            delete privileges.APPLICATION_MANAGE;
            delete privileges.MY_OPTIONAL_COURSE_SELF_REGISTER_CREATE;
            delete privileges.APPLICATION_CREATE;
        }

        if (!this.TokenService.isScormCloudEnabled()) {
            delete privileges.MY_SCORM_COURSE_VIEW;
            delete privileges.MY_SCORM_COURSE_MANAGE;
        }

        if (!this.TokenService.isEventsModuleEnabled()) {
            delete privileges.EVENTS_MANAGE;
            delete privileges.EVENTS_ADMINISTRATE;
        }

        if (!this.TokenService.isSkillsModuleEnabled()) {
            delete privileges.USER_SKILL_MANAGE;
            delete privileges.SKILL_MANAGE;
        }
        if (!this.TokenService.isAnalyticsModuleEnabled()) {
            delete privileges.ANALYTICS_VIEW;
        }

        if (!this.TokenService.isGuidanceModuleEnabled()) {
            delete privileges.GUIDANCE_MODIFY;
            delete privileges.MY_GUIDANCE_PARTICIPATE;
        }

        // NOTE: these are specific "non-visible" privileges
        delete privileges.PASSED_COURSE_VIEW;
        delete privileges.EXTERNAL_SYNC_MANAGE;
        delete privileges.LICENCE_POINT_VIEW;
        delete privileges.SALES_MARKETPLACE_USER_OCCURRENCE_MANAGE;
        delete privileges.SALES_MARKETPLACE_COURSE_VIEW;
        delete privileges.USER_EXTERNAL_REGISTER_MANAGE;
        delete privileges.LICENCE_POINTS_MANAGE;
        delete privileges.PAST_PERIOD_LICENCE_POINTS_MANAGE;
        delete privileges.NOTIFICATION_TEMPLATES_MANAGE;
        delete privileges.MY_EMPLOYEE_MANAGE;
        delete privileges.WEBINAR_EMAIL_TEMPLATES_VIEW;
        delete privileges.MARKETPLACE_INVOICE_EMAIL_TEMPLATES_VIEW;
        delete privileges.TASKLIST_TEMPLATES_MANAGE;
        delete privileges.MY_EMPLOYEE_TASKLIST_MANAGE;
        delete privileges.PRECONDITION_LICENCE_POINTS_MANAGE;
        delete privileges.MY_EMPLOYEE_ADD;
        delete privileges.ALL_LEARNERS_REPORT_VIEW;
        delete privileges.PRIVACY_SETTINGS_MANAGE;

        // In case of system role, hide all non active (checked) privileges from UI
        if (this.form.model.type === this.ROLE_TYPE_ENUM.KEYS.SYSTEM_ROLE) {
            this.lodash.forEach(privileges, (value, privilegeCode) => {
                if (!this.lodash.includes(this.form.model.privileges, privilegeCode)) {
                    delete privileges[privilegeCode];
                }
            });
        }

        return privileges;
    }

    save () {
        // delete privilegesJson key that came from the db
        delete this.form.model.privilegesJson;
        const isAddScenario = !this.form.model.id;
        this.form.save().then((model) => {
            // update role
            this.role = model;
            // set privilegesJson as privileges from which we render privileges
            this.form.model.privileges = this.form.model.privilegesJson;
            if (isAddScenario) {
                this.toastr.success(this.$translate.instant('general.Changes saved'));
                this.$state.go('authorized.manage.permissions.roles.list');
            }
        });
    }

    delete () {
        if (this.role.userCount > 0) {
            this.form.errors.name = this.$translate.instant('authorized.Deletion of the role is not allowed because there are active users connected to the role.');
        }
        else {
            this.RoleService.delete(this.role)
                .then(() => {
                    this.$state.go('authorized.manage.permissions.roles.list');
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/roles/form/index.js